/**
 * Blog post metadata registry.
 * Body content lives in the individual BlogPost_*.jsx components (preserved verbatim).
 */

export const BLOG_POSTS = [
  {
    slug: "what-is-a-dummy-ticket",
    title: "What Is a Dummy Ticket and Is It Legal for Visa Applications?",
    metaTitle:
      "What Is a Dummy Ticket? Is It Legal for Visa Applications? | GetDeparto",
    metaDescription:
      "A dummy ticket is a temporary flight reservation with a verifiable PNR, not a fake document. Learn how it works, how to verify it, and how it is used for visa applications.",
    excerpt:
      "A dummy ticket is commonly used to describe a temporary flight reservation with a verifiable PNR. Learn how it works, how to verify it, and how to avoid fake documents.",
    category: "Dummy Tickets",
    publishDate: "2026-02-12",
    wordCount: 1180,
  },
  {
    slug: "flight-reservation-for-schengen-visa",
    title:
      "How to Get a Flight Reservation for a Schengen Visa Without Buying a Confirmed Ticket",
    listTitle:
      "Flight Reservation for Schengen Visa: No Confirmed Ticket Needed",
    metaTitle:
      "Flight Reservation for Schengen Visa: No Confirmed Ticket Needed | GetDeparto",
    metaDescription:
      "Applying for a Schengen visa? Learn when a flight reservation is enough, what your booking should show, and why buying a non-refundable ticket before visa approval can be risky.",
    excerpt:
      "Applying for a Schengen visa? Learn when a flight reservation is enough, what your booking should show, and why buying a non-refundable ticket before approval can be risky.",
    category: "Schengen Visa",
    publishDate: "2026-02-12",
    wordCount: 1310,
  },
  {
  slug: "japan-visa-flight-reservation-india",
  title: "Japan Visa from India: Do You Actually Need a Flight Reservation Before You Apply?",
  listTitle: "Japan Visa from India: Flight Reservation Guide",
  metaTitle: "Japan Visa from India: Do You Need a Flight Reservation? | GetDeparto",
  metaDescription:
    "Applying for a Japan visa from India? Learn what flight itinerary documents are required, whether to buy confirmed tickets, and how a verifiable reservation helps.",
  excerpt:
    "Applying for a Japan visa from India? Learn what flight documents are actually required, why you don't need a paid ticket, and how to get your reservation right.",
  category: "Japan Visa",
  publishDate: "2026-02-12",
  wordCount: 1050,
},
{
  slug: "japan-visa-checklist-india",
  title: "Japan Visa Checklist India: Every Document You Actually Need",
  listTitle: "Japan Visa Checklist India: Documents to Prepare",
  metaTitle: "Japan Visa Checklist India: Documents to Prepare | GetDeparto",
  metaDescription:
    "Applying for a Japan visa from India? Use this practical checklist to prepare your passport, form, itinerary, flight reservation, hotel booking, bank statements, ITR, and supporting documents.",
  excerpt:
    "A complete Japan visa document checklist for Indian applicants — covering core requirements, city-wise differences, the 5-year multiple entry visa, and common mistakes to avoid.",
  category: "Japan Visa",
  publishDate: "2026-02-12",
  wordCount: 1100,
},
];

export function getPostBySlug(slug) {
  return BLOG_POSTS.find((p) => p.slug === slug);
}

// ~200 wpm read-time estimate
export function readingTime(wordCount) {
  return Math.max(1, Math.round((wordCount || 0) / 200));
}

export const SITE_ORIGIN =
  typeof window !== "undefined" && window.location?.origin
    ? window.location.origin
    : "";
